const isDateInRange = (targetDate: Date, dateRange: Date[]): boolean => {
  const targetDateWithoutTime = new Date(targetDate);
  targetDateWithoutTime.setHours(0, 0, 0, 0);

  return dateRange.some((date) => {
    const currentDateWithoutTime = new Date(date);
    currentDateWithoutTime.setHours(0, 0, 0, 0);

    return targetDateWithoutTime.getTime() === currentDateWithoutTime.getTime();
  });
};

export default isDateInRange;
